import React, { useEffect, useState, useCallback, useRef } from "react";
import { Form, Label } from "semantic-ui-react";
import { decodeCron } from "../utils/decodeCron";
import { MentionsInput, Mention } from "react-mentions";
import { varsSMS, defaultStyle, defaultMentionStyle } from "./SMSNotification";
import "./EmailNotification.scss";
import JoditEditor from "jodit-react";

const listVars = {};
varsSMS.map(item => (listVars[item.id] = item.display));

export const EmailNotification = ({
  cdEmailNotification,
  modification,
  errors,
  onChangeValuesObject
}) => {
  const [countMount, setCounMount] = useState(false);
  const typeObjectName = "cdEmailNotification";
  const editor = useRef(null);

  const editorConfig = {
    extraButtons: [
      {
        exec: function(editor, _, btnArgs) {
          editor.selection.insertHTML(`@[${btnArgs.args[1]}](${btnArgs.name})`);
        },
        iconURL: process.env.PUBLIC_URL + "/icons/img_mention.png",
        list: listVars,
        mode: 3,
        name: "insertVars",
        tooltip: "variables"
      }
    ],
    language: "es",
    readonly: false
  };

  useEffect(() => {
    const cdEmailNotificationDataSource = cdEmailNotification || {};

    if (cdEmailNotificationDataSource.template && !countMount) {
      setTemplate(cdEmailNotificationDataSource.template);
      setCounMount(true);
    }

    if (cdEmailNotificationDataSource.sendMessage)
      setSendMessage(cdEmailNotificationDataSource.sendMessage);

    if (cdEmailNotificationDataSource.subject)
      setSubject(cdEmailNotificationDataSource.subject);

    if (cdEmailNotificationDataSource.cron) {
      const [days, hours] = decodeCron(cdEmailNotificationDataSource.cron);
      setCronDays(days);
      setCronHours(hours);
    }
  }, [cdEmailNotification, countMount]);

  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    setReadOnly(modification === false);
  }, [modification]);

  const options = [
    { key: "S", text: "Si", value: true },
    { key: "N", text: "No", value: false }
  ];

  const [template, setTemplate] = useState("");
  const [sendMessage, setSendMessage] = useState(false);
  const [cronDays, setCronDays] = useState(1);
  const [cronHours, setCronHours] = useState("23:00");
  const [subject, setSubject] = useState("");

  const updateValues = () => {
    const cronHoursTemp = cronHours.split(":");
    let cronExpression = `0 ${cronHoursTemp[0] || 0} ${cronHoursTemp[1] ||
      0} 1/${cronDays} * ? *`;

    let cdEmailNotificationTempData = {
      cron: cronExpression,
      sendMessage,
      subject,
      template
    };

    onChangeValuesObject(typeObjectName, cdEmailNotificationTempData);
  };

  useEffect(() => {
    updateValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeValuesObject, sendMessage, subject, template]);

  const onChangeSubject = useCallback((_, newValue) => setSubject(newValue), [
    setSubject
  ]);

  const onChangeCronHours = useCallback(
    (_, newValue) => setCronHours(newValue.value),
    [setCronHours]
  );

  const onChangeCronDays = useCallback(
    (_, newValue) => {
      if (/^\d+$/.test(newValue.value)) setCronDays(newValue.value);
    },
    [setCronDays]
  );

  const onChangeSendMessage = useCallback(
    (_, newValue) => setSendMessage(newValue.value),
    [setSendMessage]
  );

  const onChangePlain = useCallback(newValue => setTemplate(newValue), [
    setTemplate
  ]);

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Select
          fluid
          label="Enviar mensaje"
          options={options}
          placeholder="Enviar mensaje"
          value={sendMessage}
          onChange={onChangeSendMessage}
          disabled={readOnly}
        />
        <Form.Input
          fluid
          label="Días"
          placeholder="Días"
          type="number"
          value={cronDays}
          onChange={onChangeCronDays}
          readOnly={readOnly}
          onBlur={() => (!readOnly ? updateValues() : null)}
        />
        <Form.Input
          value={cronHours}
          onChange={onChangeCronHours}
          fluid
          label="Hora"
          placeholder="Hora"
          type="time"
          readOnly={readOnly}
          onBlur={() => (!readOnly ? updateValues() : null)}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field className={errors.subject ? "error field" : ""}>
          <MentionsInput
            singleLine
            placeholder={"Asunto"}
            value={subject}
            onChange={onChangeSubject}
            style={defaultStyle}
            className="ui fluid input"
          >
            <Mention
              trigger="@"
              data={varsSMS}
              style={defaultMentionStyle}
              data-error={errors.subject}
            />
          </MentionsInput>
        </Form.Field>
      </Form.Group>

      <JoditEditor
        ref={editor}
        value={template}
        config={editorConfig}
        tabIndex={1}
        onBlur={newContent => onChangePlain(newContent)}
      />

      {errors.template ? (
        <Label basic color="red" pointing>
          {errors.template}
        </Label>
      ) : null}
    </Form>
  );
};

EmailNotification.defaultProps = {
  errors: {}
};
